export default __webpack_public_path__ + "static/media/ST4_SLEEK_LIGHT_550_K.65234676.png";